import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { registerTemplateKeys } from '../registerTemplateKeys'
import { RequestTypes } from '../requestTypes'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export type RegisterTemplatePropertiesExportPayload = {
  registerProperties: Array<Record<string, unknown>>
}

export const useExportRegisterTemplateProperties = (
  options?: UseMutationOptions<
    RegisterTemplatePropertiesExportPayload,
    RequestErrorType,
    RequestTypes['exportRegisterTemplateProperties']
  >,
) => {
  return useMutation<
    RegisterTemplatePropertiesExportPayload,
    RequestErrorType,
    RequestTypes['exportRegisterTemplateProperties']
  >({
    ...registerTemplateKeys.exportRegisterTemplateProperties,
    ...options,
  })
}
